<template>
	<div id="rules" class="rules" :class="big ? 'w-100' : ''">
		<p class="rules__text" >Deve possuir os critérios para nova senha:</p>
		<li class="rules__text" :class="verifyUppercase || !password ? '' : 'deny'">
			1 letra maiúscula
		</li>
		<li class="rules__text" :class="verifyLenght || !password ? '' : 'deny'">6 dígitos</li>
		<li class="rules__text" :class="verifySpecial || !password ? '' : 'deny'">
			1 caractere especial
		</li>
	</div>
</template>

<script>
export default {
	name: 'PasswordRules',
	props: {
		password: {
			default: '',
		},
		confirmPassword: {
			default: '',
		},
		big: {
			default: false,
		},
		tooltip: {
			default: false,
		},
	},
	methods: {
		validatedPasswords() {
			let validPassword = false;

			if (!this.password) {
				this.$toastr.e(
					'Verifique se a senha possui 6 caracteres, uma letra maíuscula e um caractere especial.',
				);
				return validPassword;
			}

			if (!this.passwordRequirements) {
				this.$toastr.e(
					'Verifique se a senha possui 6 caracteres, uma letra maíuscula e um caractere especial.',
				);
				return validPassword;
			}
			if (!this.equalPasswords) {
				this.$toastr.e('As senhas inseridas devem ser iguais.');
				return validPassword;
			}

			if (this.passwordRequirements && this.equalPasswords) validPassword = true;

			return validPassword;
		},
	},
	computed: {
		verifyUppercase() {
			const pass = this.password.toLowerCase();
			return this.password != pass ? true : false;
		},
		verifyLenght() {
			return this.password.length > 5 ? true : false;
		},
		verifySpecial() {
			let hasSpecial = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
			return hasSpecial.test(this.password) ? true : false;
		},
		passwordRequirements() {
			const reg = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#\$%\^&\*])(?=.{6,})');
			if (this.password.match(reg) !== null || this.password == '') {
				return true;
			}

			return false;
		},
		equalPasswords() {
			if (this.password == this.confirmPassword) {
				return true;
			}

			return false;
		},
	},
};
</script>

<style lang="scss" scoped>
@import 'PasswordRules.scss';
</style>
